import { useRef } from "react";
import { Table } from "antd";
import type { TableProps, ColumnsType } from "antd/es/table";
import "./style.scss";
import { Loading } from "../../components/Loading";

interface DynamicTableProps<T> extends TableProps<T> {
  data: T[];
  columns: ColumnsType<T>;
  loading?: boolean;
  isLoadMore?: boolean;
  hasMore?: boolean;
  total?: number;
  height?: string;
  rowKey?: string | ((record: T) => string);
  loadMore?: () => void;
}

const TableList = <T extends object>({
  data,
  columns,
  loading = false,
  rowKey = "id",
  isLoadMore,
  hasMore,
  height,
  loadMore,
  ...restProps
}: DynamicTableProps<T>) => {
  const tableContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div>
      <Table
        dataSource={data}
        columns={columns}
        loading={loading}
        rowKey={rowKey}
        pagination={false}
        scroll={{ y: height || "calc(100vh - 230px)" }}
        onScroll={({ target }) => {
          const { scrollTop, scrollHeight, clientHeight } = target as any;
          if (scrollTop + clientHeight >= scrollHeight - 10) loadMore?.();
        }}
        locale={{ emptyText: null }}
        {...restProps}
      />
      {isLoadMore && <Loading classes="table-loading" />}
    </div>
  );
};

export default TableList;
